module.exports = __webpack_public_path__ + "static/courier.b2496cd1.jpg";